// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TabGeneral_tab-general__sZPE5 {
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 8px 0 40px;
}
.TabGeneral_tab-general__intro__RhJ\\+\\+ {
  max-width: 760px;
  margin-bottom: -12px;
}
.TabGeneral_tab-general__intro__RhJ\\+\\+ p {
  color: var(--text-2, #6b7280);
  font-size: 14px;
  line-height: 1.65;
  margin: 0;
}
.TabGeneral_tab-general__sZPE5 {
  /* Workbench grid: crisp hairlines, no floating boxes */
}
.TabGeneral_tab-general__grid-row__hF039 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-left: 1px solid var(--light-grey, #e8e8e8);
}
@media (max-width: 1200px) {
  .TabGeneral_tab-general__grid-row__hF039 {
    grid-template-columns: 1fr;
  }
}
.TabGeneral_tab-general__grid-row-3__MrYeG {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-left: 1px solid var(--light-grey, #e8e8e8);
}
@media (max-width: 1200px) {
  .TabGeneral_tab-general__grid-row-3__MrYeG {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .TabGeneral_tab-general__grid-row-3__MrYeG {
    grid-template-columns: 1fr;
  }
}
.TabGeneral_tab-general__full-row__F-35o {
  width: 100%;
}
.TabGeneral_tab-general__actions__hOcAb {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  padding-top: 20px;
  border-top: 1px solid var(--light-grey, #e8e8e8);
}

.TabGeneral_kpi-row__8TBh2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  border-top: 1px solid var(--light-grey, #e8e8e8);
  border-left: 1px solid var(--light-grey, #e8e8e8);
}

.TabGeneral_kpi-item__-jfDZ {
  background: transparent;
  padding: 18px 20px 16px;
  border-right: 1px solid var(--light-grey, #e8e8e8);
  border-bottom: 1px solid var(--light-grey, #e8e8e8);
  border-left: 2px solid transparent;
  display: flex;
  flex-direction: column;
  gap: 0;
  transition: border-left-color 0.15s, background-color 0.15s;
}
.TabGeneral_kpi-item__-jfDZ:hover {
  background: #f9f9f9;
  border-left-color: var(--explore-color, #0f3460);
}
.TabGeneral_kpi-item__label__4-bdm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.TabGeneral_kpi-item__label-text__5El7e {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-2, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.07em;
  line-height: 1;
}
.TabGeneral_kpi-item__info__mdiDe {
  font-size: 11px;
  color: var(--text-2, #6b7280);
  cursor: help;
  opacity: 0.6;
  transition: opacity 0.1s;
}
.TabGeneral_kpi-item__info__mdiDe:hover {
  opacity: 1;
}
.TabGeneral_kpi-item__value__mvBl5 {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
  font-size: 24px;
  font-weight: 400;
  color: var(--explore-color, #0f3460);
  line-height: 1.15;
  letter-spacing: -0.02em;
  flex: 1 1;
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.TabGeneral_kpi-item__unit__uHVqF {
  font-size: 13px;
  font-weight: 400;
  color: var(--text-2, #6b7280);
  letter-spacing: 0;
}
.TabGeneral_kpi-item__footer__3rtlx {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  min-height: 20px;
}
.TabGeneral_kpi-item__badge__dvBdK {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  line-height: 1.4;
}
.TabGeneral_kpi-item__badge__dvBdK .anticon {
  font-size: 9px;
}
.TabGeneral_kpi-item__badge--up__b6nP8 {
  background: #f0fdf4;
  color: #15803d;
}
.TabGeneral_kpi-item__badge--down__Flpst {
  background: #fef2f2;
  color: #b91c1c;
}
.TabGeneral_kpi-item__badge--neutral__24hCd {
  background: #f4f4f5;
  color: var(--text-2, #6b7280);
}
.TabGeneral_kpi-item__context__n8aH8 {
  font-size: 11px;
  font-variant-numeric: tabular-nums;
  color: var(--text-2, #6b7280);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.TabGeneral_insights-section__yOYtz {
  padding: 24px 32px;
  background-color: #f0f7ff;
  border: 1px solid #e0f0ff;
  border-radius: 8px;
  margin: 16px 0;
}
.TabGeneral_insights-section__header__sP-l8 {
  margin-bottom: 24px;
}
.TabGeneral_insights-section__header__sP-l8 h3 {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-2, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.TabGeneral_insights-section__header__sP-l8 h3 .anticon {
  font-size: 14px;
  opacity: 0.7;
}
.TabGeneral_insights-section__list__5Zme7 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.TabGeneral_insight-card__FgDw7 {
  display: flex;
  background: transparent;
  border-left: 1px solid var(--light-grey, #e8e8e8);
  padding: 4px 0 4px 20px;
  transition: border-color 0.2s ease;
}
.TabGeneral_insight-card__FgDw7:hover {
  border-left-color: var(--text-2, #6b7280);
}
.TabGeneral_insight-card__indicator__oEcMh {
  display: none;
}
.TabGeneral_insight-card__body__-jX25 {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.TabGeneral_insight-card__text__q5VNk {
  font-size: 15px;
  color: var(--text-1, #1a1a2e);
  line-height: 1.6;
  font-weight: 400;
  letter-spacing: -0.01em;
}
.TabGeneral_insight-card__meta__GOaOz {
  font-size: 13px;
  color: var(--text-2, #6b7280);
  line-height: 1.5;
}

.TabGeneral_insight-highlight__H7mpM {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-weight: 500;
  color: var(--text-1, #1a1a2e);
}

.TabGeneral_partner-list__4cfbD {
  display: flex;
  flex-direction: column;
}
.TabGeneral_partner-list__item__76Qu7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 24px;
  margin: 0 -24px;
  border-bottom: 1px solid var(--light-grey, #e8e8e8);
  transition: background-color 0.15s;
}
.TabGeneral_partner-list__item__76Qu7:last-of-type {
  border-bottom: none;
}
.TabGeneral_partner-list__item__76Qu7:hover {
  background: #f8f8f8;
}
.TabGeneral_partner-list__name__QESPA {
  font-weight: 500;
  font-size: 13px;
  color: var(--text-1, #1a1a2e);
  margin-bottom: 2px;
}
.TabGeneral_partner-list__meta__ksLLm {
  font-size: 11px;
  color: var(--text-2, #6b7280);
  letter-spacing: 0.01em;
}
.TabGeneral_partner-list__score__KUkWQ {
  text-align: right;
}
.TabGeneral_partner-list__score__KUkWQ .TabGeneral_val__-Y9eg {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-variant-numeric: tabular-nums;
  font-weight: 400;
  color: var(--explore-color, #0f3460);
  font-size: 15px;
  display: block;
}
.TabGeneral_partner-list__score__KUkWQ .TabGeneral_lbl__lXc4L {
  font-size: 10px;
  color: var(--text-2, #6b7280);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  display: block;
  margin-top: 1px;
}
.TabGeneral_partner-list__view-all__yAL1j {
  margin-top: 16px;
  align-self: flex-start;
  padding: 0;
  font-size: 13px;
  color: var(--explore-color, #0f3460);
  text-decoration: none;
  border-bottom: 1px solid currentColor;
}
.TabGeneral_partner-list__view-all__yAL1j:hover {
  opacity: 0.75;
}

.TabGeneral_no-data__GtkEr {
  font-size: 13px;
  color: var(--text-2, #6b7280);
  padding: 20px 0;
  text-align: left;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/Collaborations/Tabs/General/TabGeneral.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AADF;AAGE;EACE,gBAAA;EACA,oBAAA;AADJ;AAGI;EACE,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;AADN;AAbA;EAkBE,uDAAA;AAFF;AAGE;EACE,aAAA;EACA,qCAAA;EACA,gDAAA;EACA,iDAAA;AADJ;AAGI;EANF;IAOI,0BAAA;EAAJ;AACF;AAGE;EACE,aAAA;EACA,qCAAA;EACA,gDAAA;EACA,iDAAA;AADJ;AAGI;EANF;IAOI,qCAAA;EAAJ;AACF;AAEI;EAVF;IAWI,0BAAA;EACJ;AACF;AAEE;EACE,WAAA;AAAJ;AAGE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;AADJ;;AAOA;EACE,aAAA;EACA,2DAAA;EACA,gDAAA;EACA,iDAAA;AAJF;;AAOA;EACE,uBAAA;EACA,uBAAA;EACA,kDAAA;EACA,mDAAA;EACA,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,2DAAA;AAJF;AAME;EACE,mBAAA;EACA,gDAAA;AAJJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AANJ;AASE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAPJ;AAUE;EACE,eAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;AARJ;AAUI;EACE,UAAA;AARN;AAaE;EACE,+GAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;AAXJ;AAcE;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,iBAAA;AAZJ;AAgBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;AAdJ;AAiBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,+GAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AAfJ;AAkBI;EACE,cAAA;AAhBN;AAmBI;EACE,mBAAA;EACA,cAAA;AAjBN;AAoBI;EACE,mBAAA;EACA,cAAA;AAlBN;AAqBI;EACE,mBAAA;EACA,6BAAA;AAnBN;AAuBE;EACE,eAAA;EACA,kCAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AArBJ;;AA2BA;EACE,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAxBF;AA0BE;EACE,mBAAA;AAxBJ;AA0BI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAxBN;AA0BM;EACE,eAAA;EACA,YAAA;AAxBR;AA6BE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA3BJ;;AA+BA;EACE,aAAA;EACA,uBAAA;EACA,iDAAA;EACA,uBAAA;EACA,kCAAA;AA5BF;AA8BE;EACE,yCAAA;AA5BJ;AA+BE;EACE,aAAA;AA7BJ;AAgCE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AA9BJ;AAiCE;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA/BJ;AAkCE;EACE,eAAA;EACA,6BAAA;EACA,gBAAA;AAhCJ;;AAoCA;EACE,+GAAA;EACA,gBAAA;EACA,6BAAA;AAjCF;;AAuCA;EACE,aAAA;EACA,sBAAA;AApCF;AAsCE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,mDAAA;EACA,kCAAA;AApCJ;AAsCI;EACE,mBAAA;AApCN;AAuCI;EACE,mBAAA;AArCN;AAyCE;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;AAvCJ;AA0CE;EACE,eAAA;EACA,6BAAA;EACA,sBAAA;AAxCJ;AA2CE;EACE,iBAAA;AAzCJ;AA2CI;EACE,+GAAA;EACA,kCAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,cAAA;AAzCN;AA4CI;EACE,eAAA;EACA,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AA1CN;AA8CE;EACE,gBAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;EACA,oCAAA;EACA,qBAAA;EACA,qCAAA;AA5CJ;AA8CI;EACE,aAAA;AA5CN;;AAmDA;EACE,eAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAhDF","sourcesContent":["// Doc-Ref: docs/features/collaborations-current.md\n\n.tab-general {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  padding: 8px 0 40px;\n\n  &__intro {\n    max-width: 760px;\n    margin-bottom: -12px;\n\n    p {\n      color: var(--text-2, #6b7280);\n      font-size: 14px;\n      line-height: 1.65;\n      margin: 0;\n    }\n  }\n\n  /* Workbench grid: crisp hairlines, no floating boxes */\n  &__grid-row {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    border-top: 1px solid var(--light-grey, #e8e8e8);\n    border-left: 1px solid var(--light-grey, #e8e8e8);\n\n    @media (max-width: 1200px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__grid-row-3 {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    border-top: 1px solid var(--light-grey, #e8e8e8);\n    border-left: 1px solid var(--light-grey, #e8e8e8);\n\n    @media (max-width: 1200px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n\n    @media (max-width: 768px) {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  &__full-row {\n    width: 100%;\n  }\n\n  &__actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 12px;\n    margin-top: 16px;\n    padding-top: 20px;\n    border-top: 1px solid var(--light-grey, #e8e8e8);\n  }\n}\n\n// ─── KPI Row ──────────────────────────────────────────────\n\n.kpi-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  border-top: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 1px solid var(--light-grey, #e8e8e8);\n}\n\n.kpi-item {\n  background: transparent;\n  padding: 18px 20px 16px;\n  border-right: 1px solid var(--light-grey, #e8e8e8);\n  border-bottom: 1px solid var(--light-grey, #e8e8e8);\n  border-left: 2px solid transparent;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  transition: border-left-color 0.15s, background-color 0.15s;\n\n  &:hover {\n    background: #f9f9f9;\n    border-left-color: var(--explore-color, #0f3460);\n  }\n\n  // ── Label row ────────────────────────────────────────────\n  &__label {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 8px;\n  }\n\n  &__label-text {\n    font-size: 11px;\n    font-weight: 500;\n    color: var(--text-2, #6b7280);\n    text-transform: uppercase;\n    letter-spacing: 0.07em;\n    line-height: 1;\n  }\n\n  &__info {\n    font-size: 11px;\n    color: var(--text-2, #6b7280);\n    cursor: help;\n    opacity: 0.6;\n    transition: opacity 0.1s;\n\n    &:hover {\n      opacity: 1;\n    }\n  }\n\n  // ── Primary value ─────────────────────────────────────────\n  &__value {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-variant-numeric: tabular-nums;\n    font-size: 24px;\n    font-weight: 400;\n    color: var(--explore-color, #0f3460);\n    line-height: 1.15;\n    letter-spacing: -0.02em;\n    flex: 1;\n    display: flex;\n    align-items: baseline;\n    gap: 4px;\n  }\n\n  &__unit {\n    font-size: 13px;\n    font-weight: 400;\n    color: var(--text-2, #6b7280);\n    letter-spacing: 0;\n  }\n\n  // ── Footer row: trend badge + context ─────────────────────\n  &__footer {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    margin-top: 10px;\n    min-height: 20px;\n  }\n\n  &__badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 3px;\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-variant-numeric: tabular-nums;\n    font-size: 11px;\n    font-weight: 600;\n    padding: 2px 6px;\n    border-radius: 3px;\n    line-height: 1.4;\n\n    // Antd icon inherits font-size — pin it\n    :global(.anticon) {\n      font-size: 9px;\n    }\n\n    &--up {\n      background: #f0fdf4;\n      color: #15803d;\n    }\n\n    &--down {\n      background: #fef2f2;\n      color: #b91c1c;\n    }\n\n    &--neutral {\n      background: #f4f4f5;\n      color: var(--text-2, #6b7280);\n    }\n  }\n\n  &__context {\n    font-size: 11px;\n    font-variant-numeric: tabular-nums;\n    color: var(--text-2, #6b7280);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n// ─── Insights ─────────────────────────────────────────────\n\n.insights-section {\n  padding: 24px 32px;\n  background-color: #f0f7ff;\n  border: 1px solid #e0f0ff;\n  border-radius: 8px;\n  margin: 16px 0;\n\n  &__header {\n    margin-bottom: 24px;\n\n    h3 {\n      font-size: 11px;\n      font-weight: 600;\n      color: var(--text-2, #6b7280);\n      text-transform: uppercase;\n      letter-spacing: 0.08em;\n      margin: 0;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n\n      :global(.anticon) {\n        font-size: 14px;\n        opacity: 0.7;\n      }\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n\n.insight-card {\n  display: flex;\n  background: transparent;\n  border-left: 1px solid var(--light-grey, #e8e8e8);\n  padding: 4px 0 4px 20px;\n  transition: border-color 0.2s ease;\n\n  &:hover {\n    border-left-color: var(--text-2, #6b7280);\n  }\n\n  &__indicator {\n    display: none; // Removed the synthetic blue indicator bar\n  }\n\n  &__body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  &__text {\n    font-size: 15px;\n    color: var(--text-1, #1a1a2e);\n    line-height: 1.6;\n    font-weight: 400;\n    letter-spacing: -0.01em;\n  }\n\n  &__meta {\n    font-size: 13px;\n    color: var(--text-2, #6b7280);\n    line-height: 1.5;\n  }\n}\n\n.insight-highlight {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-weight: 500;\n  color: var(--text-1, #1a1a2e);\n  // Removed synthetic pill background\n}\n\n// ─── Partner List ─────────────────────────────────────────\n\n.partner-list {\n  display: flex;\n  flex-direction: column;\n\n  &__item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 24px;\n    margin: 0 -24px;\n    border-bottom: 1px solid var(--light-grey, #e8e8e8);\n    transition: background-color 0.15s;\n\n    &:last-of-type {\n      border-bottom: none;\n    }\n\n    &:hover {\n      background: #f8f8f8;\n    }\n  }\n\n  &__name {\n    font-weight: 500;\n    font-size: 13px;\n    color: var(--text-1, #1a1a2e);\n    margin-bottom: 2px;\n  }\n\n  &__meta {\n    font-size: 11px;\n    color: var(--text-2, #6b7280);\n    letter-spacing: 0.01em;\n  }\n\n  &__score {\n    text-align: right;\n\n    .val {\n      font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n      font-variant-numeric: tabular-nums;\n      font-weight: 400;\n      color: var(--explore-color, #0f3460);\n      font-size: 15px;\n      display: block;\n    }\n\n    .lbl {\n      font-size: 10px;\n      color: var(--text-2, #6b7280);\n      text-transform: uppercase;\n      letter-spacing: 0.06em;\n      display: block;\n      margin-top: 1px;\n    }\n  }\n\n  &__view-all {\n    margin-top: 16px;\n    align-self: flex-start;\n    padding: 0;\n    font-size: 13px;\n    color: var(--explore-color, #0f3460);\n    text-decoration: none;\n    border-bottom: 1px solid currentColor;\n\n    &:hover {\n      opacity: 0.75;\n    }\n  }\n}\n\n// ─── Empty State ──────────────────────────────────────────\n\n.no-data {\n  font-size: 13px;\n  color: var(--text-2, #6b7280);\n  padding: 20px 0;\n  text-align: left;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tab-general": `TabGeneral_tab-general__sZPE5`,
	"tab-general__intro": `TabGeneral_tab-general__intro__RhJ++`,
	"tab-general__grid-row": `TabGeneral_tab-general__grid-row__hF039`,
	"tab-general__grid-row-3": `TabGeneral_tab-general__grid-row-3__MrYeG`,
	"tab-general__full-row": `TabGeneral_tab-general__full-row__F-35o`,
	"tab-general__actions": `TabGeneral_tab-general__actions__hOcAb`,
	"kpi-row": `TabGeneral_kpi-row__8TBh2`,
	"kpi-item": `TabGeneral_kpi-item__-jfDZ`,
	"kpi-item__label": `TabGeneral_kpi-item__label__4-bdm`,
	"kpi-item__label-text": `TabGeneral_kpi-item__label-text__5El7e`,
	"kpi-item__info": `TabGeneral_kpi-item__info__mdiDe`,
	"kpi-item__value": `TabGeneral_kpi-item__value__mvBl5`,
	"kpi-item__unit": `TabGeneral_kpi-item__unit__uHVqF`,
	"kpi-item__footer": `TabGeneral_kpi-item__footer__3rtlx`,
	"kpi-item__badge": `TabGeneral_kpi-item__badge__dvBdK`,
	"kpi-item__badge--up": `TabGeneral_kpi-item__badge--up__b6nP8`,
	"kpi-item__badge--down": `TabGeneral_kpi-item__badge--down__Flpst`,
	"kpi-item__badge--neutral": `TabGeneral_kpi-item__badge--neutral__24hCd`,
	"kpi-item__context": `TabGeneral_kpi-item__context__n8aH8`,
	"insights-section": `TabGeneral_insights-section__yOYtz`,
	"insights-section__header": `TabGeneral_insights-section__header__sP-l8`,
	"insights-section__list": `TabGeneral_insights-section__list__5Zme7`,
	"insight-card": `TabGeneral_insight-card__FgDw7`,
	"insight-card__indicator": `TabGeneral_insight-card__indicator__oEcMh`,
	"insight-card__body": `TabGeneral_insight-card__body__-jX25`,
	"insight-card__text": `TabGeneral_insight-card__text__q5VNk`,
	"insight-card__meta": `TabGeneral_insight-card__meta__GOaOz`,
	"insight-highlight": `TabGeneral_insight-highlight__H7mpM`,
	"partner-list": `TabGeneral_partner-list__4cfbD`,
	"partner-list__item": `TabGeneral_partner-list__item__76Qu7`,
	"partner-list__name": `TabGeneral_partner-list__name__QESPA`,
	"partner-list__meta": `TabGeneral_partner-list__meta__ksLLm`,
	"partner-list__score": `TabGeneral_partner-list__score__KUkWQ`,
	"val": `TabGeneral_val__-Y9eg`,
	"lbl": `TabGeneral_lbl__lXc4L`,
	"partner-list__view-all": `TabGeneral_partner-list__view-all__yAL1j`,
	"no-data": `TabGeneral_no-data__GtkEr`
};
export default ___CSS_LOADER_EXPORT___;
